import { Controller } from "@hotwired/stimulus";
import { Base64 } from "js-base64";
import { FetchRequest } from '@rails/request.js'
// import likert from "../../widgets/likert";
// import likertMatrix from "../../widgets/likertMatrix";
import toastr from "toastr";

// imported in CSS
// import 'survey-core/defaultV2.min.css';
import ReactDOM  from "react-dom/client";
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';

import "survey-core/i18n/french";
import "survey-core/i18n/english";
import "survey-core/i18n/portuguese";
import "survey-core/i18n/dutch";

// import { registerLikert } from '../../widgets/QuestionLikertModel';
// import theme from "../survey-theme";
import "../../widgets/likert"
import "../../widgets/likertMatrix"
import "../../widgets/noUiWidget"
import "../../widgets/noUiWidget-Custom"
import "../../widgets/noUiWidget-TLX"

// registerLikert();

export default class extends Controller {
  static targets = ["survey", "buttons", "preview", "edit"];

  static values = {
    content: String,
    currentData: String,
    resultId: Number,
    review: Boolean,
    id: Number, 
    url: String,
    locale: String,
    networkError: String,
    updateForbidden: String,
    importSuccess: String,
    importError: String,
    importMessages: Object
  };

  connect() {
    this.loadingText = this.surveyTarget.innerHTML;
    // Default toastr options.
    toastr.options = {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: "toast-bottom-right",
      preventDuplicates: false,
      onclick: null,
      showDuration: "300",
      hideDuration: "1000",
      timeOut: "5000",
      extendedTimeOut: "1000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };

    this.loadSurvey().then(() => this.formatStyleMatrix());
  }

  disconnect() {
    this.surveyTarget.innerHTML = this.loadingText;
  }

  isFakeResult() {
    return this.resultIdValue === -1;
  }

  isSubjectUpload() { 
    return this.urlValue.startsWith("import");
  }

  // Same rules as ExperimentalStudy#validate_subjects_csv! (the server stays the reference).
  // Returns an error message, or null when the file matches public/sample_data/subject_list.csv.
  subjectsCsvError(dataUri) {
    const messages = this.importMessagesValue || {};
    const bytes = Uint8Array.from(atob(dataUri.split("base64,")[1] || ""), (c) => c.charCodeAt(0));
    const text = new TextDecoder("utf-8").decode(bytes).replace(/^\uFEFF/, "");
    const lines = text.split(/\r?\n/).filter((l) => l.trim() !== "");
    const cells = (line) => line.split(",").map((c) => c.trim().replace(/^"|"$/g, "").trim());

    const headers = lines.length ? cells(lines[0]).map((h) => h.toLowerCase()) : [];
    if (headers.join(",") !== "email,anonymous") return messages.invalidHeaders;
    if (lines.length < 2) return messages.empty;

    for (let i = 1; i < lines.length; i++) {
      const [email, anonymous, ...rest] = cells(lines[i]);
      const lineNumber = String(i + 1);
      if (rest.length || !/^[^\s@]+@[^\s@]+$/.test(email || "")) {
        return (messages.invalidEmail || "").replace("{line}", lineNumber);
      }
      if (!["true", "false"].includes((anonymous || "").toLowerCase())) {
        return (messages.invalidAnonymous || "").replace("{line}", lineNumber);
      }
    }
    return null;
  }

  // Shows the CSV error under the file question as soon as the file is chosen, and blocks the submit.
  watchSubjectsFile(model) {
    model.onValidateQuestion.add((_, options) => {
      const file = options.name === "question1" && options.value && options.value[0];
      if (!file) return;
      const message = this.subjectsCsvError(file.content);
      if (message) options.error = message;
    });

    model.onValueChanged.add((_, options) => {
      if (options.name !== "question1") return;
      if (options.value && options.value.length) {
        options.question.validate(true);
      } else {
        options.question.clearErrors();
      }
    });
  }

  uploadSubjectsSurvey() {
    const messages = this.importMessagesValue || {};
    return  {
      "pages": [
       {
        "name": "page1",
        "elements": [
         {
          "type": "html",
          "name": "question2",
          "html": (this.importMessagesValue || {}).formatHelp || ""
         },
         {
          "type": "file",
          "name": "question1",
          "title": messages.fileTitle,
          "hideNumber": true,
          "isRequired": true,
          "allowImagesPreview": false,
          "acceptedTypes": "*.csv"
         },
         {
          "type": "boolean",
          "name": "assign_to_groups",
          "title": messages.assignTitle,
          "hideNumber": true,
          "defaultValue": true
         }
        ]
       }
      ],
      "showPageTitles": false,
      "showCompletedPage": false,
      "completeText": messages.send
     }
  }
  

  activateDisplayMode() {
    this.surveyModel.mode = "display";
    this.previewTarget.classList.add("inactive");
    this.editTarget.classList.remove("inactive");
  }
  activateEditMode() {
    this.surveyModel.mode = "edit";
    this.previewTarget.classList.remove("inactive");
    this.editTarget.classList.add("inactive");
  }


  // TODO: Update this, or remove it
  formatStyleMatrix() {
    // Get all matrix elements
    let items = document.querySelectorAll(".sv_q_matrix");
    items.forEach(
      (element) =>
        (element.closest(".sv_row").children[0].style.backgroundColor =
          "var(--experiment-background-color)")
    );
  }

  async loadSurvey() {
  
  
    //  survey.applyTheme(theme);

    try {
      if(this.isSubjectUpload()){
        this.surveyModel = new Model(this.uploadSubjectsSurvey());
        this.watchSubjectsFile(this.surveyModel);
      }else {
        let surveyContent = Base64.decode(this.contentValue);
        let json = JSON.parse(surveyContent);  
        this.surveyModel = new Model(json);
        // Store page width and widthMode mapping from raw JSON data
        this.pageSettingsMap = {};
        if (json.pages) {
          json.pages.forEach((page) => {
            if (page.protocol_id) {
              let pageWidth, pageWidthMode;
              
              // Priority 1: Use experience_configuration_survey_settings if available
              if (page.experience_configuration_survey_settings) {
                pageWidth = page.experience_configuration_survey_settings.width;
                pageWidthMode = page.experience_configuration_survey_settings.widthMode;
              } else {
                // Priority 2: Use page-specific settings
                pageWidth = page.page_width;
                pageWidthMode = page.page_widthMode;
              }
              
              // Priority 3: Fall back to survey-level defaults
              if (!pageWidthMode) {
                pageWidthMode = json.widthMode || 'static';
              }
              if (!pageWidth && pageWidthMode === 'static') {
                pageWidth = json.width;
              }
              
              this.pageSettingsMap[page.protocol_id] = {
                width: pageWidth,
                widthMode: pageWidthMode
              };
            }
          });
        }
      }
      
      // Load the survey questions
      if(this.hasLocaleValue){
        this.surveyModel.locale = this.localeValue;
      }

      // Apply initial page width and widthMode if available
      const firstPage = this.surveyModel.pages && this.surveyModel.pages.length > 0 ? this.surveyModel.pages[0] : null;
      if (firstPage && this.pageSettingsMap && this.pageSettingsMap[firstPage.jsonObj?.protocol_id]) {
        const pageSettings = this.pageSettingsMap[firstPage.jsonObj.protocol_id];
        this.surveyModel.widthMode = pageSettings.widthMode;
        
        // Always update width based on widthMode
        if (pageSettings.widthMode === 'responsive') {
          // For responsive: clear the width to allow full expansion
          this.surveyModel.width = '';
        } else if (pageSettings.widthMode === 'static') {
          // For static: set explicit width, use default if not specified
          this.surveyModel.width = pageSettings.width || '800';
        }
      }

      if (this.isFakeResult()) {
        this.buttonsTarget.classList.remove("hidden");
      }

      // Prepare the saved data
      if (this.hasCurrentDataValue) {
        let data = JSON.parse(Base64.decode(this.currentDataValue));
        this.surveyData = data;

        this.surveyModel.data = data;
        if (this.surveyData && this.surveyData.pageNo) {
          //console.log("Restoring page...")
          this.surveyModel.currentPageNo = this.surveyData.pageNo;
        }
      }

      if (this.reviewValue) {
        this.activateDisplayMode();
      } else {

        if(!this.isSubjectUpload()){ 
          this.autoUpdate(this.surveyModel.data, this.surveyModel.currentPageNo);

          // Hooks
          // Page change hook, update the page.
          this.surveyModel.onCurrentPageChanged.add(() => {
            this.autoUpdate.bind(this)(
              this.surveyModel.data,
              this.surveyModel.currentPageNo
            );
          });

          this.surveyModel.onCurrentPageChanged.add(() => {
            this.formatStyleMatrix();
          });

          // Update survey width and widthMode based on current page's settings
          this.surveyModel.onCurrentPageChanged.add(() => {
            const currentPage = this.surveyModel.currentPage;
            const protocolId = currentPage?.jsonObj?.protocol_id;
            if (currentPage && this.pageSettingsMap && this.pageSettingsMap[protocolId]) {
              const pageSettings = this.pageSettingsMap[protocolId];
              
              this.surveyModel.widthMode = pageSettings.widthMode;
              
              // Always update width based on widthMode
              if (pageSettings.widthMode === 'responsive') {
                // For responsive: set width to null to allow full expansion
                this.surveyModel.width = null;
              } else if (pageSettings.widthMode === 'static') {
                // For static: set explicit width, use default if not specified
                this.surveyModel.width = pageSettings.width || '800';
              }
              
            }
          });

        }

        // Complete hook, finalize the survey.
        this.surveyModel.onComplete.add(() => {
          this.sendDataToServer.bind(this)(this.surveyModel, this);
        });

        // TODO: Re-enable files and implement this 
        // Upload goes to a default attachment ?
        // this.surveyModel.onUploadFile.add(async (_, options) => { 
        //   options.files.forEach(async (file) => {
        //     const formData = new FormData();
        //     formData.append("file", file);
        //     console.log("Posting file: ", file)
        //     const request = new FetchRequest('post', 
        //       "/survey_contents/" + this.idValue + "/attach", 
        //       {
        //         body: formData
        //       })
        //     const response = await request.perform();
        //     if (response.ok) {
        //       options.callback(
        //         "success",
        //         await response.text
        //         // A link to the uploaded file                
        //     );
        //     }else {
        //     alert(response);
        //     }
        //   });
        // }); 
          

      }

      console.log("Mounting... controller connected !")
      let root = ReactDOM.createRoot(this.surveyTarget);
      root.render(<Survey model={this.surveyModel}/>);

    } catch (e) {
      console.log("Loading failed ");
      console.log(e);
    }
  }

  savePdf(data, json, SurveyPDF) {
    console.log("save");
    const surveyPdf = new SurveyPDF.SurveyPDF(json, {});
    surveyPdf.data = data;
    surveyPdf.save();
  }

  async autoUpdate(surveyData, currentPage) {
    // Add current page number
    surveyData.pageNo = currentPage;

    var resultAsString = JSON.stringify(surveyData);
    let data = {};
    data["result"] = resultAsString;
    data["userAgent"] = window.navigator.userAgent;

    let url = "";
    let type = "PATCH";

    if (!this.isFakeResult()) {
      let resultId = this.resultIdValue;
      data["id"] = resultId;

      url = "/experience_results/" + resultId + "/partial_answer";

      const request = new FetchRequest('patch', url, {
        body: JSON.stringify(data)
      })
      const response = await request.perform();

      console.log(response); 

      if (response.ok) {
         console.log("auto save OK");
      } else {
          console.log(response)
          if(response.statusCode == 401){
            toastr["warning"](this.updateForbiddenValue);
      
          } else {
            toastr["error"](this.networkError);
          }
      }

    }
  }

  async sendDataToServer(survey) {
    if (this.isFakeResult()) {
      return;
    }

    let surveyData = survey.data;
    surveyData.pageNo = survey.currentPageNo + 1;
    var resultAsString = JSON.stringify(surveyData);

    let reqData = {};
    reqData["result"] = resultAsString;
    reqData["userAgent"] = window.navigator.userAgent;

    let url = "";
    let type = "PATCH";

    let resultId = this.resultIdValue;
    reqData["id"] = resultId;
    url = "/experience_results/" + resultId + "/answer";

    if(this.isSubjectUpload()){
      url = "/experimental_studies/" + this.idValue + "/import_subjects";
    }

    if (resultId === "-1") {
      console.log("No result target, nothing is sent to server");
      return;
    }
    console.log("URL SENDING", url);
    const request = new FetchRequest('patch', url, {
      body: JSON.stringify(reqData)
    })
    const response = await request.perform();
    if (response.ok) {
        console.log("Data submitted successfully");

        if(this.isSubjectUpload()){
          toastr["success"](this.importSuccessValue);
          // Leave time to read the toast, Turbo.visit replaces the body.
          setTimeout(() => Turbo.visit("/experimental_studies/" + this.idValue + "/subject_groups"), 1500);
        }

    } else {

 
      if(response.statusCode == 401){
        toastr["warning"](this.updateForbiddenValue);
      } else if(response.statusCode == 400 && this.isSubjectUpload()){
        let message = this.importErrorValue;
        try {
          const body = await response.json;
          if(body && body.error) message = body.error;
        } catch(e) { /* not JSON: keep the generic message */ }
        toastr["error"](message);
      } else {
        toastr["error"](this.networkErrorValue);
      }

      if(response.statusCode == 400){
        if(!this.isSubjectUpload()){
          toastr["warning"]("Error in the data submitted.");
        }
        if(this.isSubjectUpload()){

          setTimeout(() => Turbo.visit("/experimental_studies/" + this.idValue + "/subject_groups"), 2000);
        }
      }
    }

  }
}